import InnerComponent from '@Components/Purchase/PurchaseRequests/PRSellerSelection';
import orgContainer from '@Components/AppContainer';

const PRSellerSelection = () => ((orgContainer(InnerComponent)));
export default PRSellerSelection;
